let arePolyfillsLoaded = false;

async function injectPolyfills() {
  if (!arePolyfillsLoaded) {
    const polyfills = [];
    let promises;

    if (window && !window.IntersectionObserver) {
      polyfills.push(import(/* webpackChunkName: "IntersectionObserverPolyfill" */ 'intersection-observer'));
    }

    if (typeof URL !== 'function') {
      polyfills.push(import(/* webpackChunkName: "url-polyfill" */ 'url-polyfill'));
    }

    try {
      promises = await Promise.all(polyfills);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to load polyfills');
    }

    arePolyfillsLoaded = true;
    return promises;
  }
}

export function onPolyfillsLoaded(callback) {
  return injectPolyfills()
    .then(callback)
    .catch(function(error) {
      console.log(error); // eslint-disable-line no-console
    });
}
